import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="flex min-h-[60vh] items-center justify-center text-muted-foreground" data-testid="loading-screen">
                Loading…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
}
